import React, { Component } from "react";
import { Form, Button, Checkbox } from "semantic-ui-react";
import axios from "axios";
import isEmpty from "validator/lib/isEmpty";
import matches from "validator/lib/matches";
import equals from "validator/lib/equals";
import contains from "validator/lib/contains";
import isEmail from "validator/lib/isEmail";
import isLength from "validator/lib/isLength";

import InlineError from "../messages/InlineError";

class EntityUserForm extends Component {
  state = {
    data: {
      activo: 0,
      nombres: "",
      apellido1: "",
      apellido2: "",
      email: "",
      login: "",
      passwd: "",
      passwdConfirmed: "",
      super_usuario: 0
    },
    isLoading: true,
    registered: false,
    errors: {}
  };

  onChange = e => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    });
  };

  validate = data => {
    const errors = {};
    if (isEmpty(data.nombres)) errors.nombres = "No puede estar en blanco.";

    if (isEmpty(data.apellido1)) errors.apellido1 = "No puede estar en blanco.";
    if (isEmpty(data.apellido2)) errors.apellido2 = "No puede estar en blanco.";

    if (isEmpty(data.login)) errors.login = "No puede estar en blanco.";

    if (!matches(data.login, /^[a-z0-9\-_.]+$/i)) {
      errors.login =
        "El nombre de usuario solo puede contener letras, números o los caracteres guión ( - ), guión bajo ( _ ) o punto ( . )";
    }
    if (isEmpty(data.passwd)) errors.passwd = "No puede estar en blanco.";

    if (contains(data.passwd, " ")) {
      errors.passwd = "La contraseña no debe contener espacios";
    }

    if (contains(data.passwd, " ")) {
      errors.passwd = "La contraseña no debe contener espacios";
    }

    if (!isLength(data.passwd, { min: 5, max: 20 })) {
      errors.passwd = "La contraseña debe contener de 5 a 20 caracteres";
    }

    if (!matches(data.passwd, /^[a-z0-9\-_.!@%$&]+$/i)) {
      errors.passwd =
        "La contraseña puede estar compuesta de letras, números o los caracteres - _ . ! @ % $ &";
    }
    if (isEmpty(data.passwdConfirmed))
      errors.passwdConfirmed = "No puede estar en blanco.";

    if (!equals(data.passwd, data.passwdConfirmed)) {
      errors.passwdConfirmed = "Las contraseñas no son iguales";
    }

    if (isEmpty(data.email)) errors.email = "No puede estar en blanco.";

    if (!isEmail(data.email))
      errors.email = "La dirección de correo está mal escrita.";

    if (contains(data.email, " ")) {
      errors.email = "La contraseña no debe contener espacios";
    }

    return errors;
  };

  onSubmit = e => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.props.submit(this.state.data);
    }
  };
  _onChangeCheckbox = (e, data) => {
    const checked = data.checked ? 1 : 0;
    this.setState({
      data: { ...this.state.data, [data.name]: checked }
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.registered !== prevProps.registered) {
      if (this.props.registered) {
        this.setState({
          registered: true
        });
      } else {
        this.setState({
          data: {
            activo: 0,
            nombres: "",
            apellido1: "",
            apellido2: "",
            email: "",
            login: "",
            passwd: "",
            passwdConfirmed: "",
            super_usuario: 0
          }
        });
      }
    }
  }

  render() {
    const { errors, data } = this.state;

    return (
      <Form onSubmit={this.onSubmit}>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.nombres}>
            <label htmlFor="nombres">Nombre(s)</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="nombres"
              name="nombres"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.nombres}
            />
            {errors.nombres && <InlineError text={errors.nombres} />}
          </Form.Field>

          <Form.Field error={!!errors.apellido1}>
            <label htmlFor="apellido1">Apellido 1</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="apellido1"
              name="apellido1"
              disabled={this.props.role === 1 ? false : true}
              onChange={this.onChange}
              value={data.apellido1}
            />
            {errors.apellido1 && <InlineError text={errors.apellido1} />}
          </Form.Field>
          <Form.Field error={!!errors.apellido2}>
            <label htmlFor="apellido2">Apellidos 2</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="apellido2"
              name="apellido2"
              onChange={this.onChange}
              value={data.apellido2}
            />
            {errors.apellido2 && <InlineError text={errors.apellido2} />}
          </Form.Field>
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field error={!!errors.login}>
            <label htmlFor="login">Usuario</label>
            <input
              className="u-full-width"
              type="text"
              placeholder=""
              id="login"
              name="login"
              autoComplete="false"
              onChange={this.onChange}
              value={data.login}
            />
            {errors.login && <InlineError text={errors.login} />}
            {this.state.registered && (
              <InlineError text="El nombre de usuario ya existe" />
            )}
          </Form.Field>
          <Form.Field error={!!errors.email}>
            <label htmlFor="email">Correo Electrónico</label>
            <input
              className="u-full-width"
              type="email"
              placeholder=""
              id="email"
              name="email"
              onChange={this.onChange}
              value={data.email}
            />
            {errors.email && <InlineError text={errors.email} />}
          </Form.Field>
          <Form.Field>
            <label htmlFor="activo">Habilitado</label>
            <Checkbox
              toggle
              name="activo"
              onChange={this._onChangeCheckbox}
              floated="right"
            />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field error={!!errors.passwd}>
            <label htmlFor="passwd">Constraseña</label>
            <input
              className="u-full-width"
              type="password"
              placeholder="Escriba su documento de identidad"
              id="passwd"
              name="passwd"
              onChange={this.onChange}
              value={data.passwd}
            />
            {errors.passwd && <InlineError text={errors.passwd} />}
          </Form.Field>
          <Form.Field error={!!errors.passwdConfirmed}>
            <label htmlFor="passwdConfirmed">Repetir constraseña</label>
            <input
              className="u-full-width"
              type="password"
              placeholder="Escriba su documento de identidad"
              id="passwdConfirmed"
              name="passwdConfirmed"
              onChange={this.onChange}
              value={data.passwdConfirmed}
            />
            {errors.passwdConfirmed && (
              <InlineError text={errors.passwdConfirmed} />
            )}
          </Form.Field>
        </Form.Group>
        <Button
          floated="right"
          color="blue"
          content="Guardar"
          icon="save"
          labelPosition="right"
        />
      </Form>
    );
  }
}

export default EntityUserForm;
